import { lazy } from 'react';

import { GuestGuard } from '@managers/guest-guard';

import { MinimalLayout } from '@widgets/layout/minimal-layout';
import { NavMotion } from '@widgets/layout/nav-motion';

import { Loadable } from '@kit/loadable';

import { ROOT, ROUTES } from './routes';

// login routing
const AuthLogin = Loadable(lazy(() => import('pages/login')));

export const LoginRoutes = {
  path: ROOT,
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: ROUTES.login,
      element: <AuthLogin />,
    },
  ],
};
